import React from 'react';
import '../styles/footer.css';
import SignupForm from './SignupForm';

const Footer = props =>
  <div className="footer">
    <span>
      <SignupForm source_id="quality_page_form" />
    </span>
  </div>;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js